export enum FormFieldType {
  STRING = 'string',
  PHONE = 'phone',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMBER = 'number',
  NUMBER_RANGE = 'number-range',
  GEO_JSON = 'geo-json',
  IMAGE = 'image',
  EXPRESSION = 'expression',
  DIVIDER = 'divider',
  TITLE = 'title',

  DATE_TIME = 'date-time',
  BOOLEAN = 'boolean',
  OPTIONS = 'options',
  OPTIONS_MULTIPLE = 'options-multiple',
  DATE = 'date',
  DATE_RANGE = 'date-range',
}
